/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const vitalDefinitions = sqliteTable('vital_definitions', {
  id: text('id').primaryKey().notNull(),
  code: text('code'),
  name: text('name'),
  unit: text('unit'),
  other_code: text('other_code'),
  value_type: text('value_type'),
  active: integer('active'),
  mandatory: integer('mandatory'),
  sort_order: integer('sort_order'),
  category: text('category'),
  deleted_at: text('deleted_at'),
  updated_at: text('updated_at'),
  updated_by: text('updated_by'),
});
